import { render, staticRenderFns } from "./BotSettingsDialog.vue?vue&type=template&id=6b4f1a32&"
import script from "./BotSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./BotSettingsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BotSettingsDialog.vue?vue&type=style&index=0&id=6b4f1a32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports